import { render, staticRenderFns } from "./MagicLinkVerify.vue?vue&type=template&id=a0d14656&"
import script from "./MagicLinkVerify.vue?vue&type=script&lang=js&"
export * from "./MagicLinkVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports